import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { type ProductsSearchDatum } from 'domains/products/components/search/utils/types'

type Props = Pick<ProductsSearchDatum, 'productCodes'>

// TODO: figure out how we want to display multiple codes
export const ProductsSearchTableProductCodesCell: FunctionComponent<Props> = ({ productCodes }) => (
  <Text>{productCodes?.[0]}</Text>
)
